import React, { useState, useCallback } from 'react';
import { Segmented } from '../../../../../../../components';
import { ComputeSettings } from './ComputeSettings';
import { StorageSettings } from './StorageSettings';
import { OSSettings } from './OSSettings';

import './Settings.scss';

export const Settings = ({
    record,
    ignoredOptimizations,
    setIgnoredOptimizations,
    additionalOptimizations,
    setAdditionalOptimizations,
    isLoading,
    scrollContainerRef,
}) => {
    const [activeSection, setActiveSection] = useState('Compute');

    // Scroll to bottom to show Apply/Revert buttons (only if not already visible)
    const scrollToBottom = useCallback(() => {
        if (!scrollContainerRef?.current) return;

        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                const container = scrollContainerRef.current;
                if (!container) return;

                const distanceFromBottom = container.scrollHeight - container.scrollTop - container.clientHeight;

                if (distanceFromBottom > 50) {
                    container.scrollTo({
                        top: container.scrollHeight,
                        behavior: 'smooth',
                    });
                }
            });
        });
    }, [scrollContainerRef]);

    const renderSection = () => {
        switch (activeSection) {
            case 'Compute':
                return (
                    <ComputeSettings
                        record={record}
                        ignoredOptimizations={ignoredOptimizations}
                        setIgnoredOptimizations={setIgnoredOptimizations}
                        additionalOptimizations={additionalOptimizations}
                        setAdditionalOptimizations={setAdditionalOptimizations}
                        isLoading={isLoading}
                        scrollToBottom={scrollToBottom}
                    />
                );
            case 'Storage':
                return (
                    <StorageSettings
                        record={record}
                        ignoredOptimizations={ignoredOptimizations}
                        setIgnoredOptimizations={setIgnoredOptimizations}
                        additionalOptimizations={additionalOptimizations}
                        setAdditionalOptimizations={setAdditionalOptimizations}
                        isLoading={isLoading}
                        scrollToBottom={scrollToBottom}
                    />
                );
            case 'OS':
                return (
                    <OSSettings
                        record={record}
                        ignoredOptimizations={ignoredOptimizations}
                        setIgnoredOptimizations={setIgnoredOptimizations}
                        additionalOptimizations={additionalOptimizations}
                        setAdditionalOptimizations={setAdditionalOptimizations}
                        isLoading={isLoading}
                        scrollToBottom={scrollToBottom}
                    />
                );
            default:
                return (
                    <ComputeSettings
                        record={record}
                        ignoredOptimizations={ignoredOptimizations}
                        setIgnoredOptimizations={setIgnoredOptimizations}
                        additionalOptimizations={additionalOptimizations}
                        setAdditionalOptimizations={setAdditionalOptimizations}
                        isLoading={isLoading}
                        scrollToBottom={scrollToBottom}
                    />
                );
        }
    };

    return (
        <div className="settings-section">
            <div className="settings-tabs">
                <Segmented
                    options={['Compute', 'Storage', 'OS']}
                    value={activeSection}
                    onChange={setActiveSection}
                    shape="round"
                />
            </div>
            <div className="settings-content">{renderSection()}</div>
        </div>
    );
};
